<template>
  <h2
    ref="title"
    class="timeline-section__title"
    :class="{
      'timeline-section__title--invert': invert
    }"
  >
    <span
      v-if="settings.hat"
      :class="textStyles[settings.hat_style]"
      v-text="settings.hat"
    />

    <span
      v-if="settings.heading"
      :class="textStyles[settings.heading_style]"
      v-html="settings.heading"
    />
  </h2>
</template>

<script>

/**
 * Vue: Timeline title (timeline-title)
 * -----------------------------------------------------------------------------
 * Reusable title markup for timeline section
 *
 */
import { mapState } from 'vuex'
import { textStyles } from '~/config/typography'

export default {
  name: 'TimelineTitle',

  props: {
    settings: {
      type: Object,
      default: () => ({
        hat: '',
        heading: '',
        hat_style: '',
        mobile_hat_style: '',
        heading_style: '',
        mobile_heading_style: '',
        invert_title: false,
        desktop_height: '',
        mobile_height: '',
      }),
    },
  },

  data() {
    return {
      textStyles,
      invert: this.settings.invert_title,
      sibling: null,
    }
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      scrollY: (state) => state.index.scroll.y,
    }),
  },

  watch: {

    /**
     * Invert title from black to white when half of the title is overlapping
     * the previous section
     */
    scrollY() {
      if (!this.settings.invert_title || !this.sibling) {
        return
      }

      const intersectThreshold = this.$refs.title.offsetHeight / 2
      const prevRect = this.sibling.getBoundingClientRect()
      const titleRect = this.$refs.title.getBoundingClientRect()
      const diff = titleRect.top - prevRect.bottom + intersectThreshold

      this.invert = diff < 0
    },
  },

  mounted() {
    this.sibling = this.$refs.title.closest('.shopify-section')?.previousElementSibling
  },
}
</script>
